import React, {useState} from "react";
import '../cart_overlay.css'
import { useCart } from "./context4cart";
import { useAuth } from "./authcontext";


export default function CartOverlay({ isbn, titel, preis, autor, m_id, onClose }) {
    const [menge, setMenge] = useState(1);
    const [bz, setBz] = useState("");
    const [vormerker, setVormerker] = useState(false);
    const { fetchWarenkorb, deleteWishlistItem, fetchWishlist } = useCart();
    const {user} = useAuth();
  
    const handleSubmit = async (e) => {
      e.preventDefault();

      
      const knr = user.aml; 
      const session_id = user.session_id;
  
      const formData = new URLSearchParams();
          formData.append("knr", knr);
          formData.append("schnell_isbn", isbn);
          formData.append("schnell_menge", menge);
          //formData.append("schnell_vormerken", vormerker ? "true" : "false");
          formData.append("schnell_vormerken", vormerker ? "on" : "");
          formData.append("schnell_bestellzeichen", bz);
          formData.append("session_id", session_id);

          try {
            const response = await fetch("/api-add2wk", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: formData.toString(),
            });

            const result = await response.json();
            console.log("Result:", result);

            //alert("Artikel wurde(n) in den Warenkorb gelegt");
            fetchWarenkorb();
            fetchWishlist();


            // Herr Reutter möchte erstmal nicht, dass Items, die in den WK verschoben werden, von der Liste gelöscht werden
            //Falls er es doch möchte, müssen die folgenden drei Zeilen wieder rein
           // if (m_id) {
           //   await deleteWishlistItem(m_id);
           // }

            onClose(); // Close overlay
          } catch (err) {
            console.error("Error:", err);
            alert("Artikel konnte nicht hinzugefügt werden.");
          }
    };
  
    return (
      <div className="item2CartOverlay">
        <div className="cartOverlayContent">
          <form onSubmit={handleSubmit}>
            <div className='cartOverlayContentItem'> <h4>In den Warenkorb:</h4></div>
           
            <div className='cartOverlayTitle cartOverlayContentItem'><h5><b>{titel}</b></h5></div>
            <div className='cartOverlayPAICombinded'>
                <div className='cartOverlayAutor cartOverlayISBN'>{autor}<br/>{isbn}</div>
                
                <div className='cartOverlayPreis'>{preis.toFixed(2).replace('.', ',')}€ </div>

            </div>
            




            <br/>
            <div className='cartOverlayField cartOverlayContentItem'>
              
                <select value={menge} onChange={(e) => setMenge(e.target.value)}>
                    {[...Array(10)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                        Menge: {i + 1}
                    </option>
                    ))}
                </select>
            </div>

            <div className='cartOverlayField cartOverlayBZ cartOverlayContentItem'>
                <input type="text" value={bz} onChange={(e) => setBz(e.target.value)} placeholder='Bestellzeichen' />
            </div>        
            
              
            <div className='cartOverlayField cartOverlayContentItem styledCheckbox'><label> Vormerken:
                <input type="checkbox" checked={vormerker} onChange={(e) => setVormerker(e.target.checked)} />
                <span class="customCheckbox"></span>
                </label>
            </div>   
                    
            <br/>        
  
            <div className='cartOverlayContentItem'>
              <button type="submit" className='umbButton'> Hinzufügen</button>
              <button type="button" className='umbButton' onClick={onClose}>Abbrechen</button>
            </div>
          </form>
        </div>
  
       
      </div>
    );
  }